import { Flex } from 'antd';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

import { SimpleCard } from 'ui/SimpleCard';

import styles from './index.module.scss';

export const FilterCard = ({ children }: PropsWithChildren) => {
  return (
    <SimpleCard>
      <Flex align="center" gap={24}>
        {children}
      </Flex>
    </SimpleCard>
  );
};

export const CustomFilterCard = ({
  children,
  footer,
}: PropsWithChildren<{ footer?: ReactNode }>) => {
  return (
    <div className={styles.card}>
      <Flex
        align="center"
        gap={24}
        className={classNames(
          styles.body,
          footer ? styles.bodyWithFooter : undefined,
        )}
      >
        {children}
      </Flex>
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </div>
  );
};
